import { Attrs, MinzeElement } from 'minze'

export interface LvcCharlieEcouteIcon {
  width?: number
  height?: number
}

export class LvcCharlieEcouteIcon extends MinzeElement {
  attrs: Attrs = [
    ['width', 157],
    ['height', 157],
  ]
  html = () => `
    <img width="${this.width}" height="${this.height}" src="https://cloud.squidex.io/api/assets/lvc-dev/6d97e950-e3d0-427d-9e5e-07c5d03ee41b/ecoute.png?version=1&auto=true" loading="eager"/>
  `

  css = () => `
`
}
